import { Table, Tag } from "antd";
import { useNavigate, useLocation } from "react-router-dom";

const columns = [
  {
    title: "Thumbnail",
    dataIndex: "thumbnail",
    key: "image",
    render: (image: string) => <img style={{ width: 75 }} src={image} />,
  },
  {
    title: "Naam",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Status",
    dataIndex: "hidden",
    key: "hidden",
    render: (hidden: boolean) =>
      hidden ? (
        <Tag color="orange">Verborgen</Tag>
      ) : (
        <Tag color="green">Zichtbaar</Tag>
      ),
  },
];

interface Props {
  brickCollections: any[] | null;
}

const OrganizationBrickCollections: React.FC<Props> = ({ brickCollections }) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Table
      loading={brickCollections == null}
      columns={columns}
      dataSource={brickCollections ?? undefined}
      onRow={(record) => {
        return {
          onClick: () =>
            navigate(
              `${location.pathname}/collections/${record._id}`
            ),
        };
      }}
    />
  );
};

export default OrganizationBrickCollections;
